module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<article class='container-fluid main-content'>\n\n\n\n\t<% text.blocks.forEach(function(block){ %>\n\n\n\t\t<% if (block.Type === 'ai2html') { %>\n\t\t\t</article>\n\t\t\t<section class=\"graphic  snap borderless <%=block.ID%>\">\n\t\t\t\t<div id=\"<%=block.ID%>\"></div>\n\t\t\t</section>\n\t\t\t<article class='container-fluid main-content'>\n\t\t<% } %>\n\n\t\t<% if (block.Type === 'aside') { %>\n\t\t    <div class=\"dek\"><%=text.Dek%></div>\n\n\t\t    <aside class=\"article-metadata\">\n\t\t        <div class=\"byline-container\">\n\t\t            <div class=\"byline\">\n\t\t                By<strong>&nbsp;<a href=\"https://www.reuters.com/journalists/david-lague\" target=\"blank\">David Lague</a>&nbsp;</strong>and <strong><a href=\"https://twitter.com/lightnosugar\" target=\"blank\">Maryanne Murray</a>&nbsp;</strong>\n\t\t            </div>\n\t\t        </div>\n\n\t\t        <div class=\"dateline-container\">\n\t\t\t\t      <div class=\"published\">\n\t\t\t\t        Published <time class='time'> Nov. 5, 2021</time>\n\t\t\t\t      </div>\n\t\t        </div>\n\t\t    </aside>\n\n\t\t<% } %>\n\n\n\t\t<% if (block.Type === 'lottie') { %>\n\t\t\t\t<%if (block.Has_Key){%>\n\t\t\t\t\t<img class=\"key <%=block.ID%>\" <%if(block.Key_Start_Seconds){%>keystart = \"<%=block.Key_Start_Seconds%>\" <%}%> <%if(block.Key_End_Seconds){%>keyend = \"<%=block.Key_End_Seconds%>\" <%}%> <%if(block.Key_Switch_Seconds){%>keyswitch = \"<%=block.Key_Switch_Seconds%>\" <%}%> src=\"<%=graphic_url_path%>img/key_<%=block.ID%>.png\">\n\t\t\t\t<%}%>\n\n\t\t\t\t<div id=\"lottie-<%=block.ID%>\" class=\"lottie-target mb-5\">\n\t\t\t\t\t<%if (block.Blurb_id){\n\t\t\t\t\t\ttext[block.Blurb_id].forEach(function(blurb){%>\n\t\t\t\t\t\t\t<div class=\"blurb\" <%if(blurb.Seconds){%>seconds='<%=blurb.Seconds%>'<%}%>><%- parseMarkdown(blurb.Text) %></div>\n\n\t\t\t\t\t\t<%})\n\t\t\t\t\t}%>\n\t\t\t\t</div>\n\t  <% } %>\n\n\n\t\t<% if (block.Type === 'page_text') {\n\t\t\ttext[block.Blurb_id].forEach(function(blurb){%>\n\t\t\t\t<section class=\"body-text\">\n\t\t\t\t\t<%- parseMarkdown(blurb.Text) %>\n\t\t\t\t</section>\n\t\t\t<%})%>\n\n\t  <% } %>\n\n\n\t<% }); %>\n\n\n\t<section class='end-notes'>\n\t\t<%- parseMarkdown(text.EndNotes) %>\n\t</section>\n\t<div id=\"footnote-shade\"></div>\n\t<% text.footnotes.forEach(function(footnote,i){\n\t\tconsole.log(footnote.Text)\n\t%>\n\t\t<div class=\"footnote\" id=\"footnote<%=footnote.Number%>\">\n\t\t\t<div class=\"close-box\"><div>x</div></div>\n\t\t\t<div class=\"footnote-content\"><%- parseMarkdown(footnote.Text) %></div>\n\t\t\t<%if(footnote.Link){%>\n\t\t\t\t<a class=\"footnote-readmore\" href=\"<%=footnote.Link%>\" target=\"_blank\" >Read more</a>\n\t\t\t<%}%>\n\t\t</div>\n\n\t<% }); %>\n\n</article>\n"
  , __filename = "/Users/matthewweber/dev/taiwan/src/js/article.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<article class='container-fluid main-content'>\n\n\n\n	")
    ; __line = 5
    ;  text.blocks.forEach(function(block){ 
    ; __append("\n\n\n		")
    ; __line = 8
    ;  if (block.Type === 'ai2html') { 
    ; __append("\n			</article>\n			<section class=\"graphic  snap borderless ")
    ; __line = 10
    ; __append(escapeFn(block.ID))
    ; __append("\">\n				<div id=\"")
    ; __line = 11
    ; __append(escapeFn(block.ID))
    ; __append("\"></div>\n			</section>\n			<article class='container-fluid main-content'>\n		")
    ; __line = 14
    ;  } 
    ; __append("\n\n		")
    ; __line = 16
    ;  if (block.Type === 'aside') { 
    ; __append("\n		    <div class=\"dek\">")
    ; __line = 17
    ; __append(escapeFn(text.Dek))
    ; __append("</div>\n\n		    <aside class=\"article-metadata\">\n		        <div class=\"byline-container\">\n		            <div class=\"byline\">\n		                By<strong>&nbsp;<a href=\"https://www.reuters.com/journalists/david-lague\" target=\"blank\">David Lague</a>&nbsp;</strong>and <strong><a href=\"https://twitter.com/lightnosugar\" target=\"blank\">Maryanne Murray</a>&nbsp;</strong>\n		            </div>\n		        </div>\n\n		        <div class=\"dateline-container\">\n				      <div class=\"published\">\n				        Published <time class='time'> Nov. 5, 2021</time>\n				      </div>\n		        </div>\n		    </aside>\n\n		")
    ; __line = 33
    ;  } 
    ; __append("\n\n\n		")
    ; __line = 36
    ;  if (block.Type === 'lottie') { 
    ; __append("\n				")
    ; __line = 37
    ; if (block.Has_Key){
    ; __append("\n					<img class=\"key ")
    ; __line = 38
    ; __append(escapeFn(block.ID))
    ; __append("\" ")
    ; if(block.Key_Start_Seconds){
    ; __append("keystart = \"")
    ; __append(escapeFn(block.Key_Start_Seconds))
    ; __append("\" ")
    ; }
    ; __append(" ")
    ; if(block.Key_End_Seconds){
    ; __append("keyend = \"")
    ; __append(escapeFn(block.Key_End_Seconds))
    ; __append("\" ")
    ; }
    ; __append(" ")
    ; if(block.Key_Switch_Seconds){
    ; __append("keyswitch = \"")
    ; __append(escapeFn(block.Key_Switch_Seconds))
    ; __append("\" ")
    ; }
    ; __append(" src=\"")
    ; __append(escapeFn(graphic_url_path))
    ; __append("img/key_")
    ; __append(escapeFn(block.ID))
    ; __append(".png\">\n				")
    ; __line = 39
    ; }
    ; __append("\n\n				<div id=\"lottie-")
    ; __line = 41
    ; __append(escapeFn(block.ID))
    ; __append("\" class=\"lottie-target mb-5\">\n					")
    ; __line = 42
    ; if (block.Blurb_id){
						text[block.Blurb_id].forEach(function(blurb){
    ; __line = 43
    ; __append("\n							<div class=\"blurb\" ")
    ; __line = 44
    ; if(blurb.Seconds){
    ; __append("seconds='")
    ; __append(escapeFn(blurb.Seconds))
    ; __append("'")
    ; }
    ; __append(">")
    ; __append( parseMarkdown(blurb.Text) )
    ; __append("</div>\n\n						")
    ; __line = 46
    ; })
					}
    ; __line = 47
    ; __append("\n				</div>\n	  ")
    ; __line = 49
    ;  } 
    ; __append("\n\n\n		")
    ; __line = 52
    ;  if (block.Type === 'page_text') {
			text[block.Blurb_id].forEach(function(blurb){
    ; __line = 53
    ; __append("\n				<section class=\"body-text\">\n					")
    ; __line = 55
    ; __append( parseMarkdown(blurb.Text) )
    ; __append("\n				</section>\n			")
    ; __line = 57
    ; })
    ; __append("\n\n	  ")
    ; __line = 59
    ;  } 
    ; __append("\n\n\n	")
    ; __line = 62
    ;  }); 
    ; __append("\n\n\n	<section class='end-notes'>\n		")
    ; __line = 66
    ; __append( parseMarkdown(text.EndNotes) )
    ; __append("\n	</section>\n	<div id=\"footnote-shade\"></div>\n	")
    ; __line = 69
    ;  text.footnotes.forEach(function(footnote,i){
		console.log(footnote.Text)
	
    ; __line = 71
    ; __append("\n		<div class=\"footnote\" id=\"footnote")
    ; __line = 72
    ; __append(escapeFn(footnote.Number))
    ; __append("\">\n			<div class=\"close-box\"><div>x</div></div>\n			<div class=\"footnote-content\">")
    ; __line = 74
    ; __append( parseMarkdown(footnote.Text) )
    ; __append("</div>\n			")
    ; __line = 75
    ; if(footnote.Link){
    ; __append("\n				<a class=\"footnote-readmore\" href=\"")
    ; __line = 76
    ; __append(escapeFn(footnote.Link))
    ; __append("\" target=\"_blank\" >Read more</a>\n			")
    ; __line = 77
    ; }
    ; __append("\n		</div>\n\n	")
    ; __line = 80
    ;  }); 
    ; __append("\n\n</article>\n")
    ; __line = 83
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=/Users/matthewweber/dev/taiwan/src/js/article.ejs

}